// Wisconsin fence-permit guidance — all 72 counties + the statewide rules.
//
// Ground truth about WI fence permits: the Uniform Dwelling Code does NOT
// regulate fences, so requirements are LOCAL — city/village zoning inside
// municipal limits, county zoning in unincorporated towns, plus county
// shoreland zoning near lakes/rivers. That means the honest automation is:
// resolve the parcel's county (the estimator's WI Statewide Parcels layer
// carries CONAME), surface the right office + a targeted search, and track
// submitted/approved on the work order. Per-county portal URLs/fees get
// verified and filled into COUNTY_NOTES over time — never guessed.

export interface WiCounty { name: string; seat: string; fips: string }

export const WI_COUNTIES: WiCounty[] = [
  { name: "Adams", seat: "Friendship", fips: "55001" },
  { name: "Ashland", seat: "Ashland", fips: "55003" },
  { name: "Barron", seat: "Barron", fips: "55005" },
  { name: "Bayfield", seat: "Washburn", fips: "55007" },
  { name: "Brown", seat: "Green Bay", fips: "55009" },
  { name: "Buffalo", seat: "Alma", fips: "55011" },
  { name: "Burnett", seat: "Siren", fips: "55013" },
  { name: "Calumet", seat: "Chilton", fips: "55015" },
  { name: "Chippewa", seat: "Chippewa Falls", fips: "55017" },
  { name: "Clark", seat: "Neillsville", fips: "55019" },
  { name: "Columbia", seat: "Portage", fips: "55021" },
  { name: "Crawford", seat: "Prairie du Chien", fips: "55023" },
  { name: "Dane", seat: "Madison", fips: "55025" },
  { name: "Dodge", seat: "Juneau", fips: "55027" },
  { name: "Door", seat: "Sturgeon Bay", fips: "55029" },
  { name: "Douglas", seat: "Superior", fips: "55031" },
  { name: "Dunn", seat: "Menomonie", fips: "55033" },
  { name: "Eau Claire", seat: "Eau Claire", fips: "55035" },
  { name: "Florence", seat: "Florence", fips: "55037" },
  { name: "Fond du Lac", seat: "Fond du Lac", fips: "55039" },
  { name: "Forest", seat: "Crandon", fips: "55041" },
  { name: "Grant", seat: "Lancaster", fips: "55043" },
  { name: "Green", seat: "Monroe", fips: "55045" },
  { name: "Green Lake", seat: "Green Lake", fips: "55047" },
  { name: "Iowa", seat: "Dodgeville", fips: "55049" },
  { name: "Iron", seat: "Hurley", fips: "55051" },
  { name: "Jackson", seat: "Black River Falls", fips: "55053" },
  { name: "Jefferson", seat: "Jefferson", fips: "55055" },
  { name: "Juneau", seat: "Mauston", fips: "55057" },
  { name: "Kenosha", seat: "Kenosha", fips: "55059" },
  { name: "Kewaunee", seat: "Kewaunee", fips: "55061" },
  { name: "La Crosse", seat: "La Crosse", fips: "55063" },
  { name: "Lafayette", seat: "Darlington", fips: "55065" },
  { name: "Langlade", seat: "Antigo", fips: "55067" },
  { name: "Lincoln", seat: "Merrill", fips: "55069" },
  { name: "Manitowoc", seat: "Manitowoc", fips: "55071" },
  { name: "Marathon", seat: "Wausau", fips: "55073" },
  { name: "Marinette", seat: "Marinette", fips: "55075" },
  { name: "Marquette", seat: "Montello", fips: "55077" },
  { name: "Menominee", seat: "Keshena", fips: "55078" },
  { name: "Milwaukee", seat: "Milwaukee", fips: "55079" },
  { name: "Monroe", seat: "Sparta", fips: "55081" },
  { name: "Oconto", seat: "Oconto", fips: "55083" },
  { name: "Oneida", seat: "Rhinelander", fips: "55085" },
  { name: "Outagamie", seat: "Appleton", fips: "55087" },
  { name: "Ozaukee", seat: "Port Washington", fips: "55089" },
  { name: "Pepin", seat: "Durand", fips: "55091" },
  { name: "Pierce", seat: "Ellsworth", fips: "55093" },
  { name: "Polk", seat: "Balsam Lake", fips: "55095" },
  { name: "Portage", seat: "Stevens Point", fips: "55097" },
  { name: "Price", seat: "Phillips", fips: "55099" },
  { name: "Racine", seat: "Racine", fips: "55101" },
  { name: "Richland", seat: "Richland Center", fips: "55103" },
  { name: "Rock", seat: "Janesville", fips: "55105" },
  { name: "Rusk", seat: "Ladysmith", fips: "55107" },
  { name: "St. Croix", seat: "Hudson", fips: "55109" },
  { name: "Sauk", seat: "Baraboo", fips: "55111" },
  { name: "Sawyer", seat: "Hayward", fips: "55113" },
  { name: "Shawano", seat: "Shawano", fips: "55115" },
  { name: "Sheboygan", seat: "Sheboygan", fips: "55117" },
  { name: "Taylor", seat: "Medford", fips: "55119" },
  { name: "Trempealeau", seat: "Whitehall", fips: "55121" },
  { name: "Vernon", seat: "Viroqua", fips: "55123" },
  { name: "Vilas", seat: "Eagle River", fips: "55125" },
  { name: "Walworth", seat: "Elkhorn", fips: "55127" },
  { name: "Washburn", seat: "Shell Lake", fips: "55129" },
  { name: "Washington", seat: "West Bend", fips: "55131" },
  { name: "Waukesha", seat: "Waukesha", fips: "55133" },
  { name: "Waupaca", seat: "Waupaca", fips: "55135" },
  { name: "Waushara", seat: "Wautoma", fips: "55137" },
  { name: "Winnebago", seat: "Oshkosh", fips: "55139" },
  { name: "Wood", seat: "Wisconsin Rapids", fips: "55141" },
];

/* statewide facts every WI fence job shares (kept conservative + true) */
export const WI_STATEWIDE = [
  "Wisconsin's Uniform Dwelling Code doesn't regulate fences — permits are LOCAL zoning (height, setbacks, corner-lot sight lines).",
  "Inside city/village limits the MUNICIPAL zoning office governs — check there first; the county governs unincorporated towns.",
  "County shoreland zoning can apply near lakes & rivers even where no other permit is needed.",
  "Diggers Hotline (811) is required by Wis. Stat. 182.0175 at least 3 business days before digging — separate from the permit.",
  "Pool fences/barriers have their own code requirements regardless of zoning.",
];

/* verified per-county notes get added here over time (portal URL, fee,
   processing days). Empty = the panel shows the targeted search instead —
   we never show a guessed link. */
export const COUNTY_NOTES: Record<string, { portal?: string; note?: string }> = {};

export function findCounty(name?: string | null): WiCounty | null {
  if (!name) return null;
  const n = String(name).trim().toLowerCase().replace(/\s+county$/, "");
  return WI_COUNTIES.find((c) => c.name.toLowerCase() === n) || null;
}

export function permitSearchUrl(county: string) {
  return "https://www.google.com/search?q=" + encodeURIComponent(`${county} County WI fence permit zoning`);
}
export function countyZoningSearchUrl(county: string) {
  return "https://www.google.com/search?q=" + encodeURIComponent(`${county} County Wisconsin planning zoning department`);
}

/* county for a work order: its linked quote's parcel (the WI parcels layer
   stamps CONAME on resolve) — else null and the panel offers the selector. */
export function detectCountyForWo(wo: any, store: any): string | null {
  const q = (store.quotes || []).find((x: any) => x.id === wo.quoteId)
    || (store.projects || []).find((p: any) => p.id === wo.projectId && p.snapshot) && null;
  const county = q && q.inputs && q.inputs.parcel && q.inputs.parcel.county;
  return county ? (findCounty(county) ? findCounty(county)!.name : String(county)) : null;
}

/* ---- FW-025: "Block scheduling until the permit is filed", enforced --------
   The toggle used to produce one events row that nothing read, so a contractor
   could switch it on, book the job, and roll a crew to a site with no permit —
   having been told the software was stopping exactly that. The server stamps
   wo.permitHold when the permit automation sees a booked job in a jurisdiction
   that requires one; scheduling happens here in the app, so this is the gate.

   Mirrors permitBlocks()/permitBlockMessage() in server/src/permithold.js —
   permithold.test.mjs fails if the two disagree.

   The override is not a loophole, it is the point. Permits get pulled by
   phone, walked in, or waived by an inspector; software that can't be
   overruled by the person holding the permit gets worked around instead of
   used. What matters is that the decision is explicit and leaves a trace. */
export function permitBlocks(wo: any): { reason: string; jurisdiction: string | null } | null {
  const hold = wo && wo.permitHold;
  if (!hold || !hold.required || !hold.blocking) return null;
  const readiness = (wo && wo.readiness) || {};
  if (readiness.permit) return null;                                  // marked approved
  if (wo && wo.permitOverride && wo.permitOverride.at) return null;   // overruled, on the record
  return {
    reason: (readiness.permitInfo && readiness.permitInfo.submittedAt) ? "submitted" : "not-filed",
    jurisdiction: hold.jurisdiction || null,
  };
}

export function permitBlockMessage(block: any): string {
  if (!block) return "";
  const where = block.jurisdiction ? ` in ${block.jurisdiction}` : "";
  return block.reason === "submitted"
    ? `This job${where} needs a permit and yours is submitted but not approved yet. Mark it approved on the work order once it comes through — or schedule anyway if you're confident it'll land before the crew rolls.`
    : `This job${where} needs a permit and nothing has been filed. Pull it first, then mark it approved on the work order — or schedule anyway if you're handling the permit another way.`;
}
